import React from "react";
import { FlaskConical } from "lucide-react";
import { useAuth } from "../contexts/AuthContext";

/** Shown at the top of the app shell when the signed-in user is a demo user
 *  (isDemoUser=true) — a soft reminder that this workspace is shared with
 *  other visitors and outbound integrations (email, SMS) are muted. */
export default function DemoBanner() {
  const { user } = useAuth();
  if (!user?.isDemoUser) return null;
  return (
    <div
      data-testid="demo-mode-banner"
      className="w-full bg-gradient-to-r from-cyan-500/15 via-sky-500/10 to-transparent border-b border-cyan-400/20 px-4 py-2 flex items-center gap-2 text-[12.5px]"
    >
      <span className="inline-flex items-center justify-center h-6 w-6 rounded-md bg-cyan-500/25 text-cyan-200 shrink-0">
        <FlaskConical className="h-3.5 w-3.5" />
      </span>
      <span className="text-cyan-100 font-semibold">You&apos;re in the demo.</span>
      <span className="text-slate-300 hidden sm:inline">
        This workspace is shared with other visitors — feel free to explore. Emails and
        texts are muted so nothing goes out to real people.
      </span>
    </div>
  );
}
